import { FormikProvider, Form } from 'formik';
import { XTextarea, XInput } from '../../components';
import useTeamForm from '../../hooks/useTeamForm';
import XSearchMultiSelect from '../common/XSearchMultiSelect';
import XModal from '../common/XModal';

const formRowClasses = "row pt-4!";
const usersBoxClasses = "p-3 border border-border rounded";

const TeamForm = ({ isOpen, onClose, onSubmit, isFormSubmitting, selectedTeam }) => {
    const { formik, users, onSearch } = useTeamForm({ selectedTeam, onSubmit });

    return (
        <XModal
            isOpen={isOpen}
            title={selectedTeam ? 'Edit Team' : 'Add Team'}
            onClose={onClose}
            onSubmit={formik.handleSubmit}
            submitText="Save"
            isSubmitting={isFormSubmitting}
            size="lg"
        >
            <FormikProvider value={formik}>
                <Form>
                    <div className={formRowClasses}>
                        <div className="w-full">
                            <div className="mb-4">
                                <XInput name="name" placeholder="Enter Name" label="Name" {...formik.getFieldProps('name')} error={formik.touched.name && formik.errors.name} />
                            </div>
                        </div>

                        <div className="w-full">
                            <div className="mb-4">
                                <XTextarea placeholder="Enter Description" label="Description" {...formik.getFieldProps('description')} />
                            </div>
                        </div>

                        <div className="w-full">
                            <div className={usersBoxClasses}>
                                <XSearchMultiSelect
                                    label="Users"
                                    value={formik.values.userIds}
                                    onChange={(next) => formik.setFieldValue('userIds', next)}
                                    items={users}
                                    onSearch={onSearch}
                                    getItemLabel={(u) => `${u.firstName} ${u.lastName}`}
                                />
                            </div>
                        </div>
                    </div>
                </Form>
            </FormikProvider>
        </XModal>
    );
};

export default TeamForm;
